<template lang="pug">
  .container-listagem
    visualizar-portaria(
      v-if="showModalVisualizarPortaria",
      :width="modalWidth"
      :titulo="'Visualizar Portaria'",
      :bytes="portariaPdfBytes",
      @closeModal="closeModalVisualizarPortaria"
      )
    visualizar-matricula(
      v-if="showModalVisualizarMatricula",
      :width="modalWidth"
      :titulo="'Visualizar Matrícula'",
      :bytes="matriculaPdfBytes",
      @closeModal="closeModalVisualizarMatricula"
      )

    modal-assinatura(
      v-if="showModalAssinatura"
      :width="modalWidth"
      titulo="Assinar Ofício(s)"
      texto="Para realizar a assinatura de ofícios é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
      @closeModal="closeModalAssinatura"
      @callbackSucesso="assinatura"
    )

    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'20px', 'border-radius':'10px'}"
        )

    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :showButtonAssinatura="true",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="processosArrecadacao",
      :totalElements="totalCadastros",
      :pagina="pagina",
      :filtro="filtro"
      @updateListagem="resetPesquisa",
      @changePage="changePage",
      @sort="sortChanged",
      @selected="false",
      @selectItem="selectItem",
      :disableButtonAssinaturaTitulo="idsProcessosAssinatura.length == 0",
      @executar="executar"
      @assinarTitulos="ASSINATURA"
    )

</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import cloneDeep from 'lodash/cloneDeep'
import VisualizarPortaria from './portaria/VisualizarPortaria'
import VisualizarMatricula from './matricula/VisualizarMatricula'
import AppListagem from '@/components/AppListagem'
import BaseFiltroArrecadacao from '../../mixins/BaseFiltroArrecadacao'
import ModalAssinatura from '@/components/ModalAssinatura'
import statusProcesso from '@/constants/statusProcessoArrecadacao'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  ordem: null,
  ordemDirecao: null
}

export default {
  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    VisualizarPortaria,
    AppListagem,
    ModalAssinatura,
    VisualizarMatricula
  },

  data () {
    return {
      colunas: [
        {
          propriedade: 'numeroProcesso',
          id: 0,
          titulo: 'Processo',
          marcado: () => true,
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'cadastroColetivo.pecaTecnica.gleba',
          id: 1,
          titulo: 'Gleba',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'dataChegadaSetor',
          id: 2,
          titulo: 'Data',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          propriedade: 'cadastroColetivo.pecaTecnica.municipios',
          id: 3,
          titulo: 'Município',
          formatter: this.formatMunicipio,
          acoes: []
        },
        {
          propriedade: 'statusName',
          id: 4,
          titulo: 'Situação',
          formatter: Utils.formatEmptyRow,
          acoes: []
        },
        {
          id: 5,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 6,
          acoes: [
            {
              id: 1,
              nome: 'Visualizar Processo',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_PROCESSO',
              ordem: 1
            },
            {
              id: 2,
              nome: 'Visualizar Portaria',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_PORTARIA',
              ordem: 2
            },
            {
              id: 3,
              show: this.showMatricula,
              nome: 'Visualizar Ofício de Matrícula',
              icone: 'fa-eye',
              codigo: 'VISUALIZAR_MATRICULA',
              ordem: 3
            }
          ]
        }
      ],
      filtro: cloneDeep(FILTRO_EMPTY),
      Utils,
      portariaPdfBytes: null,
      matriculaPdfBytes: null,
      showModalVisualizarPortaria: false,
      showModalAssinatura: false,
      showModalVisualizarMatricula: false,
      idsProcessosAssinatura: [],
      processosSelecionados: [],
      modalWidth: null
    }
  },

  mixins: [BaseFiltroArrecadacao, AppNotificacao],

  created () {
    this.setMainCardVisibility(false)
    this.init()
    this.modalWidth = (window.screen.width * 80) / 100
  },

  methods: {
    async VISUALIZAR_PORTARIA (_this, { item }) {
      this.portariaPdfBytes = await this.emitirPortaria(item.id)
      this.showModalVisualizarPortaria = true
    },

    async VISUALIZAR_MATRICULA (_this, { item }) {
      this.matriculaPdfBytes = await this.getPDFMatricula(item.matricula.id)
      this.showModalVisualizarMatricula = true
    },

    async VISUALIZAR_PROCESSO (_this, { item }) {
      this.$router.push({
        name: 'gp/visualizarProcesso',
        query: {
          idProcesso: item.id
        }
      })
    },

    async ASSINATURA (_this) {
      this.showModalAssinatura = true
    },

    showMatricula (processo) {
      return processo.status === statusProcesso.AGUARDANDO_ASSINATURA_MATRICULA
    },

    selectItem (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        const existe = this.idsProcessosAssinatura.find(i => i === item.id)
        if (!existe) {
          this.idsProcessosAssinatura.push(item.id)
          this.processosSelecionados.push(item)
        }
      } else {
        this.idsProcessosAssinatura = this.idsProcessosAssinatura.filter(
          i => i !== item.id
        )
        this.processosSelecionados = this.processosSelecionados.filter(
          i => i.id !== item.id
        )
      }
    },

    closeModalVisualizarPortaria () {
      this.showModalVisualizarPortaria = false
    },

    closeModalAssinatura () {
      this.showModalAssinatura = false
      this.processosSelecionados = []
      this.idsProcessosAssinatura = []
      this.init()
    },

    closeModalVisualizarMatricula () {
      this.showModalVisualizarMatricula = false
    },

    async assinatura (senha) {
      try {
        const response = await this.assinar({
          dadosAssinatura: { idProcessos: this.idsProcessosAssinatura, senha }
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          response
        )
      } catch (error) {
        this.showErroValidacao(
          this.$messages.ERRO_VALIDACAO,
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING
        )
      }
      this.closeModalAssinatura()
    },

    modalAssinatura () {
      this.showModalAssinatura = true
    },

    ...mapActions({
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      emitirPortaria: 'portariaArrecadacao/emitirPortaria',
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula',
      assinar: 'processoArrecadacao/tramitarComAssinatura'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/GpListagemPresidente.vue